// 36 Hex to reduce the size of the file
export default {
  aliceblue: '9ehhb',
  antiquewhite: '9sgk7',
  aqua: '1ekf',
  aquamarine: '4zsno',
  azure: '9eiv3',
  beige: '9lhp8',
  bisque: '9zg04',
  black: '0',
  blanchedalmond: '9zhe5',
  blue: '73',
  blueviolet: '5e31e',
  brown: '6g016',
  burlywood: '8ouiv',
  cadetblue: '3qba8',
  chartreuse: '4zshs',
  chocolate: '87k0u',
  coral: '9yvyo',
  cornflowerblue: '3xael',
  cornsilk: '9zjz0',
  crimson: '8l4xo',
  cyan: '1ekf',
  darkblue: '3v',
  darkcyan: 'rkb',
  darkgoldenrod: '776yz',
  darkgray: '6mbhl',
  darkgreen: 'jr4',
  darkgrey: '6mbhl',
  darkkhaki: '7ehkb',
  darkmagenta: '5f91n',
  darkolivegreen: '3bzfz',
  darkorange: '9yygw',
  darkorchid: '5z6x8',
  darkred: '5f8xs',
  darksalmon: '9441m',
  darkseagreen: '5lwgf',
  darkslateblue: '2th1n',
  darkslategray: '1ugcv',
  darkslategrey: '1ugcv',
  darkturquoise: '14up',
  darkviolet: '5rw7n',
  deeppink: '9yavn',
  deepskyblue: '11xb',
  dimgray: '442g9',
  dimgrey: '442g9',
  dodgerblue: '16xof',
  firebrick: '6y7tu',
  floralwhite: '9zkds',
  forestgreen: '1cisi',
  fuchsia: '9y70f',
  gainsboro: '8m8kc',
  ghostwhite: '9pq0v',
  goldenrod: '8j4f4',
  gold: '9zda8',
  gray: '50i2o',
  green: 'pa8',
  greenyellow: '6senj',
  grey: '50i2o',
  honeydew: '9eiuo',
  hotpink: '9yrp0',
  indianred: '80gnw',
  indigo: '2xcoy',
  ivory: '9zldc',
  khaki: '9edu4',
  lavenderblush: '9ziet',
  lavender: '90c8q',
  lawngreen: '4vk74',
  lemonchiffon: '9zkct',
  lightblue: '6s73a',
  lightcoral: '9dtog',
  lightcyan: '8s1rz',
  lightgoldenrodyellow: '9sjiq',
  lightgray: '89jo3',
  lightgreen: '5nkwg',
  lightgrey: '89jo3',
  lightpink: '9z6wx',
  lightsalmon: '9z2ii',
  lightseagreen: '19xgq',
  lightskyblue: '5arju',
  lightslategray: '4nwk9',
  lightslategrey: '4nwk9',
  lightsteelblue: '6wau6',
  lightyellow: '9zlcw',
  lime: '1edc',
  limegreen: '1zcxe',
  linen: '9shk6',
  magenta: '9y70f',
  maroon: '4zsow',
  mediumaquamarine: '40eju',
  mediumblue: '5p',
  mediumorchid: '79qkz',
  mediumpurple: '5r3rv',
  mediumseagreen: '2d9ip',
  mediumslateblue: '4tcku',
  mediumspringgreen: '1di2',
  mediumturquoise: '2uabw',
  mediumvioletred: '7rn9h',
  midnightblue: 'z980',
  mintcream: '9ljp6',
  mistyrose: '9zg0x',
  moccasin: '9zfzp',
  navajowhite: '9zest',
  navy: '3k',
  oldlace: '9wq92',
  olive: '50hz4',
  olivedrab: '472ub',
  orange: '9z3eo',
  orangered: '9ykg0',
  orchid: '8iu3a',
  palegoldenrod: '9bl4a',
  palegreen: '5yw0o',
  paleturquoise: '6v4ku',
  palevioletred: '8k8lv',
  papayawhip: '9zi6t',
  peachpuff: '9ze0p',
  peru: '80oqn',
  pink: '9z8wb',
  plum: '8nba5',
  powderblue: '6wgdi',
  purple: '4zssg',
  rebeccapurple: '3zk49',
  red: '9y6tc',
  rosybrown: '7cv4f',
  royalblue: '2jvtt',
  saddlebrown: '5fmkz',
  salmon: '9rvci',
  sandybrown: '9jn1c',
  seagreen: '1tdnb',
  seashell: '9zje6',
  sienna: '6973h',
  silver: '7ir40',
  skyblue: '5arjf',
  slateblue: '45e4t',
  slategray: '4e100',
  slategrey: '4e100',
  snow: '9zke2',
  springgreen: '1egv',
  steelblue: '2r1kk',
  tan: '87yx8',
  teal: 'pds',
  thistle: '8ggk8',
  tomato: '9yqfb',
  turquoise: '2j4r4',
  violet: '9b10u',
  wheat: '9ld4j',
  white: '9zldr',
  whitesmoke: '9lhpx',
  yellow: '9zl6o',
  yellowgreen: '61fzm'
};